module.exports = __webpack_public_path__ + "img/image13.84d772df.png";